export default __webpack_public_path__ + "static/media/Chat_alt_2_fill.ff90fe39.svg";